import React, { useState, useEffect, forwardRef } from "react";
import { useHistory } from "react-router-dom";

import {
  Button,
  Dialog,
  IconButton,
  Typography,
  Slide,
  Grid,
  CircularProgress,
  Box,
  TextField,
  MenuItem,
} from "@mui/material";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { API } from "@services/API";
import { useSnackbar } from "notistack";

import moment from "moment";

moment.updateLocale("en", {
  week: {
    dow: 1,
  },
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function headers() {
  let headers = {};
  let token = localStorage.getItem("covid19_token");
  let mfa_token = localStorage.getItem("mfa_token");
  if (token && token.length > 0 && mfa_token && mfa_token.length > 0) {
    headers = { "x-access-token": token };
  }
  return headers;
}

export default function UserAddEditDialog({
  isVisible,
  onClose,
  onSave,
  dataHospitals,
  dataAccessLevels,
  dataUser,
  ...props
}) {
  let history = useHistory();

  const hospitalID = localStorage.getItem("hospital_id");

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(true);

  const [data, setData] = useState({
    user_id: null,
    firstname: "",
    surname: "",
    email: "",
    password: "",
    tablet_pin: null,
    hospital_id: null,
    level_id: null,
    is_tablet_only: false,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showPin, setShowPin] = useState(false);

  useEffect(() => {
    const timeOut = setTimeout(() => {
      if (!isNullOrEmpty(dataUser)) {
        let existingUser = {
          user_id: isNullOrEmpty(dataUser.user_id) ? null : dataUser.user_id,
          firstname: isNullOrEmpty(dataUser.firstname)
            ? ""
            : dataUser.firstname,
          surname: isNullOrEmpty(dataUser.surname) ? "" : dataUser.surname,
          email: isNullOrEmpty(dataUser.username) ? "" : dataUser.username,
          password: isNullOrEmpty(dataUser.password) ? "" : dataUser.password,
          tablet_pin: isNullOrEmpty(dataUser.tablet_pin)
            ? null
            : dataUser.tablet_pin,
          hospital_id: isNullOrEmpty(dataUser.hospital_id)
            ? null
            : dataUser.hospital_id,
          level_id: isNullOrEmpty(dataUser.level_id) ? null : dataUser.level_id,
          is_tablet_only: !isValidEmail(dataUser.username) ? true : false,
        };

        setData(existingUser);
      }
      setLoading(false);
    }, 200);

    return () => clearTimeout(timeOut);
  }, []);

  const showSnackBar = (type, title, subtitle) => {
    const options = { variant: type };

    enqueueSnackbar(
      <div style={{ display: "inline-grid" }}>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="subtitle1">{subtitle}</Typography>
      </div>,
      options
    );
  };

  const isNullOrEmpty = (value) => {
    if (value === null || value === undefined) {
      return true;
    }

    if (typeof value === "string" && value.trim().toLowerCase() === "null") {
      return true;
    }

    if (Array.isArray(value) && value.length === 0) {
      return true;
    }

    if (typeof value === "string" && value.trim() === "") {
      return true;
    }

    if (typeof value === "number" && isNaN(value)) {
      return true;
    }

    return false;
  };

  const isValidEmail = (email) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    } else {
      return false;
    }
  };

  const isValidPassword = (value) => {
    let regEx =
      /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*_\-+=`|(){}\[\]:;"'<>,.?/])(?=\S+$).{8,20}$/;
    return regEx.test(value);
  };

  const isValidPin = (value) => {
    let regEx = /^\d{4}$/;
    return regEx.test(value);
  };

  const handleSave = () => {
    if (isNullOrEmpty(data.firstname)) {
      showSnackBar("error", "Failure", "Firstname name can't be empty.");
    } else if (isNullOrEmpty(data.surname)) {
      showSnackBar("error", "Failure", "Surname name can't be empty.");
    } else if (isNullOrEmpty(data.tablet_pin)) {
      showSnackBar("error", "Failure", "Tablet PIN can't be empty.");
    } else if (!isValidPin(data.tablet_pin)) {
      showSnackBar(
        "error",
        "Failure",
        "Tablet PIN code must be 4 numeric digits."
      );
    } else if (!data.is_tablet_only && isNullOrEmpty(data.email)) {
      showSnackBar("error", "Failure", "Email name can't be empty.");
    } else if (!data.is_tablet_only && !isValidEmail(data.email)) {
      showSnackBar("error", "Failure", "Invalid email address.");
    } else if (!data.is_tablet_only && isNullOrEmpty(data.password)) {
      showSnackBar("error", "Failure", "Portal password can't be empty.");
    } else if (!data.is_tablet_only && !isValidPassword(data.password)) {
      showSnackBar(
        "error",
        "Failure",
        "Password must contain at least 8 characters and at most 20 characters, with at least one digit, one upper case letter, one lower case letter, and one special character from the set:\n\n ~!@#$%^&*_-+=`|(){}[]:;'<\">,.?/\n\nIt must not contain any white space."
      );
    } else if (isNullOrEmpty(data.level_id)) {
      showSnackBar("error", "Failure", "Access level can't be empty.");
    } else if (
      data.level_id !== 1 &&
      data.level_id !== 2 &&
      data.level_id !== 3 &&
      isNullOrEmpty(data.hospital_id)
    ) {
      showSnackBar("error", "Failure", "Hospital can't be empty.");
    } else {
      const userBody = {
        admin_user_id: Number(localStorage.getItem("user_id")),
        admin_facility_id: Number(localStorage.getItem("user_facility_id")),
        user_id: data.user_id,
        level: data.level_id,
        firstname: data.firstname,
        surname: data.surname,
        username: data.is_tablet_only ? data.firstname : data.email,
        email: data.is_tablet_only ? data.firstname : data.email,
        password: data.password,
        hospital_id: isNullOrEmpty(data.hospital_id)
          ? Number(hospitalID)
          : Number(data.hospital_id),
        tablet_pin: data.tablet_pin,
        is_tablet_only: data.is_tablet_only,
      };

      API.post("/user", userBody, {
        headers: headers(),
      })
        .then((response) => {
          showSnackBar(
            "success",
            "Success",
            "Successfully saved user details."
          );
          onSave();
        })
        .catch((error) => {
          if (error.response.data.message === "PIN already used.") {
            showSnackBar(
              "error",
              "Failure",
              "Change PIN as the entered one is already been used by another user."
            );
          } else if (error.response.data.message === "Email already in use.") {
            showSnackBar(
              "error",
              "Failure",
              "Change EMAIL as the entered one is already been used by another user."
            );
          } else {
            showSnackBar("error", "Failure", "Failed to save user details.");
          }
        });
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      open={isVisible}
      onClose={handleClose}
      TransitionComponent={Transition}
      PaperProps={{
        style: {
          backgroundColor: "#FFF",
          boxShadow: "none",
        },
      }}
    >
      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          margin: 15,
        }}
      >
        {loading ? (
          <CircularProgress color="primary" />
        ) : (
          <>
            <Grid
              container
              spacing={2}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Grid
                item
                xs={12}
                md={12}
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Typography data-test={"users-add-user-title"} variant="h6">
                  User Details
                </Typography>
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  data-test={"users-add-user-firstname"}
                  fullWidth
                  required
                  label="Firstname"
                  size="small"
                  type="text"
                  value={data.firstname}
                  onChange={(e) =>
                    setData({
                      ...data,
                      firstname: e.target.value,
                    })
                  }
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  data-test={"users-add-user-surname"}
                  fullWidth
                  required
                  label="Surname"
                  size="small"
                  type="text"
                  value={data.surname}
                  onChange={(e) =>
                    setData({ ...data, surname: e.target.value })
                  }
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  data-test={"users-add-user-pin"}
                  fullWidth
                  required
                  label="Tablet Pin"
                  size="small"
                  type={showPin ? "text" : "password"}
                  value={data.tablet_pin}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (
                      inputValue === "" ||
                      (!isNaN(inputValue) && parseFloat(inputValue) >= 0)
                    ) {
                      setData({
                        ...data,
                        tablet_pin: inputValue,
                      });
                    } else {
                      showSnackBar(
                        "error",
                        "Failure",
                        "Invalid tablet pin number value."
                      );
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <IconButton onClick={() => setShowPin(!showPin)}>
                        {showPin ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <TextField
                  data-test={"users-add-user-access"}
                  select
                  fullWidth
                  required
                  label="User Access"
                  size="small"
                  value={data.is_tablet_only}
                  disabled={
                    !isNullOrEmpty(data.user_id) && isValidEmail(data.email)
                  }
                  onChange={(e) =>
                    setData({
                      ...data,
                      is_tablet_only: e.target.value,
                      email: "",
                      password: "",
                    })
                  }
                >
                  <MenuItem value={false}>Portal and Tablet</MenuItem>
                  <MenuItem value={true}>Tablet Only</MenuItem>
                </TextField>
              </Grid>

              {!data.is_tablet_only && (
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    required
                    label="Email"
                    size="small"
                    type="email"
                    value={data.email}
                    onChange={(e) =>
                      setData({ ...data, email: e.target.value })
                    }
                  />
                </Grid>
              )}

              {!data.is_tablet_only && (
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    required
                    label="Portal Password"
                    size="small"
                    type={showPassword ? "text" : "password"}
                    value={data.password}
                    onChange={(e) =>
                      setData({ ...data, password: e.target.value })
                    }
                    InputProps={{
                      endAdornment: (
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      ),
                    }}
                  />
                </Grid>
              )}

              <Grid item xs={12} md={12}>
                <TextField
                  data-test={"users-add-user-access-level"}
                  select
                  fullWidth
                  required
                  label="Access Level"
                  size="small"
                  value={data.level_id}
                  onChange={(e) =>
                    setData({
                      ...data,
                      level_id: e.target.value,
                      hospital_id:
                        Number(e.target.value) === 1 ||
                        Number(e.target.value) === 2 ||
                        Number(e.target.value) === 3
                          ? hospitalID
                          : null,
                    })
                  }
                >
                  {dataAccessLevels.map((type) => (
                    <MenuItem key={type.level_id} value={type.level_id}>
                      {type.level_description}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {!isNullOrEmpty(data.level_id) &&
                data.level_id !== 1 &&
                data.level_id !== 2 &&
                data.level_id !== 3 && (
                  <Grid item xs={12} md={12}>
                    <TextField
                      data-test={"users-add-user-hospital"}
                      select
                      fullWidth
                      required
                      label="Hospital"
                      size="small"
                      value={data.hospital_id}
                      onChange={(e) =>
                        setData({
                          ...data,
                          hospital_id: e.target.value,
                        })
                      }
                    >
                      {dataHospitals.map((type) => (
                        <MenuItem key={type.id} value={type.id}>
                          {type.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                )}

              <Grid
                item
                xs={12}
                md={12}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  flexDirection: "row",
                }}
              >
                <Button
                  data-test={"users-add-user-cancel-btn"}
                  variant="contained"
                  color="primary"
                  style={{ marginLeft: 10 }}
                  onClick={handleClose}
                >
                  Cancel
                </Button>

                <Button
                  data-test={"users-add-user-save-btn"}
                  variant="contained"
                  color="primary"
                  style={{ marginLeft: 10 }}
                  onClick={handleSave}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </>
        )}
      </Box>
    </Dialog>
  );
}
